import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import { useSeo } from "@/utils/seo";
import {
  getFeaturedArticles,
  getHotArticles,
  getLatestArticles,
} from "@/utils/articles";
import { categories } from "@/mocks/categories";

export default function Home() {
  useSeo({
    title: "黑料 - 最新娱乐八卦与揭秘资讯平台",
    description:
      "黑料网站提供丰富的娱乐八卦、明星隐秘消息和社会热点揭秘，覆盖影视、综艺、娱乐新闻等多个领域，帮您第一时间了解最新内幕动态。",
    keywords: "黑料,娱乐八卦,明星黑料,内幕揭秘,娱乐新闻,社会热点,影视资讯",
    canonicalPath: "/",
  });

  const featured = getFeaturedArticles();
  const latest = getLatestArticles(10);
  const hot = getHotArticles(8);

  return (
    <SiteLayout>
      <div className="px-4 md:px-6 py-5 md:py-8 space-y-12 md:space-y-20">
        <HeroCarousel items={featured} />

        <section>
          <SectionHeading
            icon="ri-apps-2-line"
            title="分类快捷入口"
            subtitle="按你关心的方向快速进入对应频道"
          />
          <CategoryGrid />
        </section>

        <section className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <SectionHeading
              icon="ri-newspaper-line"
              title="最新资讯"
              subtitle="按发布时间倒序，实时更新圈内动态"
            />
            <div className="space-y-3">
              {latest.map((article) => (
                <ArticleCard key={article.id} article={article} variant="horizontal" />
              ))}
            </div>
          </div>

          <aside className="space-y-8">
            <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
              <div className="flex items-center gap-2 mb-3">
                <span className="w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className="ri-fire-line" />
                </span>
                <h2 className="font-heading font-extrabold text-lg">热门内容推荐</h2>
              </div>
              <div>
                {hot.map((article, i) => (
                  <ArticleCard
                    key={article.id}
                    article={article}
                    variant="rank"
                    rank={i + 1}
                  />
                ))}
              </div>
            </div>

            <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-4 md:p-5">
              <h2 className="font-heading font-bold text-base mb-3">热门标签</h2>
              <div className="flex flex-wrap gap-2">
                {[...new Set(hot.flatMap((item) => item.tags))].slice(0, 12).map((tag) => (
                  <Link
                    key={tag}
                    to={`/search?q=${encodeURIComponent(tag)}`}
                    className="px-3 py-1.5 rounded-full bg-background-50 border border-secondary-200 text-xs text-secondary-900 hover:border-primary-300 hover:text-primary-600 transition cursor-pointer"
                  >
                    # {tag}
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </section>

        <section>
          <SectionHeading
            icon="ri-live-line"
            title="更多频道速览"
            subtitle="不同分类的精选内容，一次看个够"
          />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {categories.map((category) => {
              const list = getLatestArticles().filter((item) => item.category === category.slug).slice(0, 3);
              return (
                <div key={category.slug} className="border border-background-200 rounded-lg p-4 md:p-5">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                        <i className={category.icon} />
                      </span>
                      <h3 className="font-heading font-bold text-base">{category.name}</h3>
                    </div>
                    <Link
                      to={`/category/${category.slug}`}
                      className="text-xs text-foreground-600 hover:text-primary-600 transition cursor-pointer whitespace-nowrap"
                    >
                      全部 <i className="ri-arrow-right-line" />
                    </Link>
                  </div>
                  <div className="space-y-2.5">
                    {list.map((item) => (
                      <Link
                        key={item.id}
                        to={`/detail/${item.id}`}
                        className="flex items-start gap-2 text-sm text-foreground-700 hover:text-primary-600 transition cursor-pointer"
                      >
                        <i className="ri-checkbox-blank-circle-fill text-[6px] mt-2 text-primary-400 shrink-0" />
                        <span className="line-clamp-2 leading-snug">{item.title}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        <section className="relative overflow-hidden rounded-lg bg-primary-950 text-background-50 px-6 md:px-12 py-10 md:py-14">
          <div className="relative z-10 max-w-2xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/10 text-xs mb-4">
              <i className="ri-information-line" />
              关于黑料
            </span>
            <h2 className="font-heading font-extrabold text-xl md:text-3xl leading-tight mb-3">
              第一时间，看懂娱乐圈背后的故事
            </h2>
            <p className="text-sm md:text-base text-background-200/85 leading-relaxed mb-6">
              黑料聚合娱乐八卦、明星隐秘消息与社会热点揭秘，用清晰的分类与深度解析，帮你在信息洪流中快速抓住重点。我们坚持真实、客观、可核查的信息整理方式，让每一个热点都有据可循。
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition cursor-pointer whitespace-nowrap"
              >
                了解我们
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/category/entertainment"
                className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-50/35 text-sm hover:bg-background-50/10 transition cursor-pointer whitespace-nowrap"
              >
                浏览娱乐八卦
              </Link>
            </div>
          </div>
          <i className="ri-mic-2-line absolute -right-6 -bottom-8 text-[180px] text-background-50/5" />
        </section>
      </div>
    </SiteLayout>
  );
}